

const initialState = {
  id: "infotext-modal",
  title: "",
  isOpen: false,
  setIsOpen: () => { },
  content: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "MODAL_UPDATE":
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
